import React from 'react';
import moment from 'moment';

import CurrencySign from 'components/price/CurrencySign.component';
import S from 'constants/string.const';
import { withTranslation } from 'providers/GILT.provider';
import asArray from 'utils/arrays/asArray.util';
import { formatDateByLocale } from 'utils/date/format.util';
import { isEnvMobile } from 'utils/env/determine.util';
import logger from 'utils/logger.util';
import createNodeKey from 'utils/react/createNodeKey.util';
const L = logger('ClientList');

const STICKY_NAVBAR_CLIENTS_SELECTOR = '.sticky-navbar-clients';

const fromBirthdayToFormatted = (birthday) => {
  if (!birthday) return S.empty;

  const [day, month, year] = birthday.split('/');
  const fullBirthYear = `${year}-${month}-${day}`;

  if (year) return formatDateByLocale(new Date(fullBirthYear), { dateFormat: 'D MMM YYYY' });

  return formatDateByLocale(new Date(fullBirthYear), { dateFormat: 'D MMM' });
};

const fromPatchTestDateToFormatted = (patchTestDate) => {
  if (!patchTestDate) return S.empty;

  const [day, month, year] = patchTestDate.split('/');
  const fullDate = `${year}-${month}-${day}`;

  return formatDateByLocale(new Date(fullDate), { dateFormat: 'D MMM YYYY' });
};

class ClientList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: true,
      isNameAcs: false,
      isMobileAsc: true,
      isLastVisitAsc: false,
      isNextVisitAsc: false,
      isToatalVisitsAsc: true,
      isAverageAsc: true,
      isNoShowAsc: true,
      isCancelAsc: true,
      isLastSMSSentAsc: true,
      isTotalSpendAsc: true,
      isEmailAsc: true,
      isPatchTestAsc: true,
      isBirthdayAsc: true,
      isTagsAsc: true,
    };
  }

  toggleChange = () => {
    this.setState({ isChecked: !this.state.isChecked });
    this.props.markAllClientsSelect(!this.state.isChecked);
  };

  toggleItemChange = (clientId, clientSelection) => {
    this.props.markClientSelect(clientId, !clientSelection);
  };

  sortItemClicked = (tableRow) => {
    if (tableRow === 'clientName') {
      this.setState({ isNameAcs: !this.state.isNameAcs });
      this.props.sortClientList(tableRow, this.state.isNameAcs);
      this.props.trackEvent('sort_clients_name');
    }
    if (tableRow === 'mobile') {
      this.setState({ isMobileAsc: !this.state.isMobileAsc });
      this.props.sortClientList(tableRow, this.state.isMobileAsc);
      this.props.trackEvent('sort_clients_mobile');
    }
    if (tableRow === 'lastVisit') {
      this.setState({ isLastVisitAsc: !this.state.isLastVisitAsc });
      this.props.sortClientList(tableRow, this.state.isLastVisitAsc);
      this.props.trackEvent('sort_clients_lastvisit');
    }
    if (tableRow === 'nextVisit') {
      this.setState({ isNextVisitAsc: !this.state.isNextVisitAsc });
      this.props.sortClientList(tableRow, this.state.isNextVisitAsc);
      this.props.trackEvent('sort_clients_nextvisit');
    }
    if (tableRow === 'totalVisits') {
      this.setState({ isToatalVisitsAsc: !this.state.isToatalVisitsAsc });
      this.props.sortClientList(tableRow, this.state.isToatalVisitsAsc);
      this.props.trackEvent('sort_clients_totalvisits');
    }
    if (tableRow === 'averageBill') {
      this.setState({ isAverageAsc: !this.state.isAverageAsc });
      this.props.sortClientList(tableRow, this.state.isAverageAsc);
      this.props.trackEvent('sort_clients_avgbill');
    }
    if (tableRow === 'noShow') {
      this.setState({ isNoShowAsc: !this.state.isNoShowAsc });
      this.props.sortClientList(tableRow, this.state.isNoShowAsc);
      this.props.trackEvent('sort_clients_noshow');
    }
    if (tableRow === 'Cancellations') {
      this.setState({ isCancelAsc: !this.state.isCancelAsc });
      this.props.sortClientList(tableRow, this.state.isCancelAsc);
      this.props.trackEvent('sort_clients_cancellations');
    }
    if (tableRow === 'lastSmsSent') {
      this.setState({ isLastSMSSentAsc: !this.state.isLastSMSSentAsc });
      this.props.sortClientList(tableRow, this.state.isLastSMSSentAsc);
      this.props.trackEvent('sort_clients_last_sms');
    }
    if (tableRow === 'totalSpend') {
      this.setState({ isTotalSpendAsc: !this.state.isTotalSpendAsc });
      this.props.sortClientList(tableRow, this.state.isTotalSpendAsc);
      this.props.trackEvent('sort_total_spend');
    }
    if (tableRow === 'email') {
      this.setState({ isEmailAsc: !this.state.isEmailAsc });
      this.props.sortClientList(tableRow, this.state.isEmailAsc);
      this.props.trackEvent('sort_email');
    }
    if (tableRow === 'invalid_patch_test') {
      this.setState({ isPatchTestAsc: !this.state.isPatchTestAsc });
      this.props.sortClientList(tableRow, this.state.isPatchTestAsc);
      this.props.trackEvent('sort_patch_test');
    }
    if (tableRow === 'birthday') {
      this.setState({ isBirthdayAsc: !this.state.isBirthdayAsc });
      this.props.sortClientList(tableRow, this.state.isBirthdayAsc);
      this.props.trackEvent('sort_birthday');
    }
    if (tableRow === 'clientTags') {
      this.setState({ isTagsAsc: !this.state.isTagsAsc });
      this.props.sortClientList(tableRow, this.state.isTagsAsc);
      this.props.trackEvent('sort_tags');
    }
  };

  render() {
    if (isEnvMobile({ regex: true })) {
      const div = document.querySelector(STICKY_NAVBAR_CLIENTS_SELECTOR);
      if (div) {
        // Code smell, event is not removed on unmount, dom is manipulated directly
        div.addEventListener('touchstart touchmove touchend', (ev) => void ev.preventDefault());
      } else {
        L.warn('render()', 'Missing element:', STICKY_NAVBAR_CLIENTS_SELECTOR);
      }
    }

    const { t } = this.props;

    return (
      <>
        <div className="sticky-navbar-clients">
          <div className="client-list-header">
            <div className="opt-chk">
              <div className="cb-item">
                <div className="checkbox-box-custom-wrap">
                  <input type="checkbox" className="checkbox-box-custom" id="clients-opted-in" checked={this.props.isOptChecked} onChange={this.props.toggleOptChange} />
                  <label className="checkbox-box-label" htmlFor="clients-opted-in">
                    <div className="checkbox-box-custom-icon">
                      <span className="ic-sml-18px ic_check_white_18" />
                    </div>
                  </label>
                </div>
                <span className="span-text">{t('allClients.clientsList.optedInMarketing')}</span>
                <div className="client-oped-icon">
                  <span className="tooltip">
                    <div className="tooltip-centered">{t('allClients.clientsList.optedInMarketingTooltip')}</div>
                  </span>
                </div>
              </div>
              <div className="cb-item">
                <div className="checkbox-box-custom-wrap chk-nophone">
                  <input type="checkbox" className="checkbox-box-custom" id="clients-hide" checked={this.props.isHideChecked} onChange={this.props.toggleHideChange} />
                  <label className="checkbox-box-label" htmlFor="clients-hide">
                    <div className="checkbox-box-custom-icon">
                      <span className="ic-sml-18px ic_check_white_18" />
                    </div>
                  </label>
                </div>
                <span className="span-text">{t('allClients.clientsList.hideClientsWithNoMobile')}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="sticky-container-clients">
          <div className="sticky-table-marketing">
            <table className="table-clients">
              <thead>
                <tr>
                  <th className="check-box-row">
                    <div className="checkbox-box-custom-wrap">
                      <input type="checkbox" className="checkbox-box-custom" id="clients-check" checked={this.state.isChecked} onChange={this.toggleChange} />
                      <label className="checkbox-box-label" htmlFor="clients-check">
                        <div className="checkbox-box-custom-icon">
                          <span className="ic-sml-18px ic_check_white_18" />
                        </div>
                      </label>
                    </div>
                  </th>
                  <th className="c-name">
                    <div role="button" tabIndex={0} onClick={() => this.sortItemClicked('clientName')} className="ht-name">
                      {t('allClients.clientsList.clientName')}
                      <div className="diamond-arrow" />
                    </div>
                  </th>
                  <th className="c-mobile">
                    <div role="button" tabIndex={0} onClick={() => this.sortItemClicked('mobile')} className="ht-name">
                      {t('allClients.clientsList.mobile')}
                      <div className="diamond-arrow" />
                    </div>
                  </th>
                  <th className="c-last-v">
                    <div role="button" tabIndex={0} onClick={() => this.sortItemClicked('lastVisit')} className="ht-name">
                      <span>{t('allClients.clientsList.lastVisit')}</span>

                      <div className="diamond-arrow" />
                    </div>
                  </th>
                  <th className="c-next-v">
                    <div role="button" tabIndex={0} onClick={() => this.sortItemClicked('nextVisit')} className="ht-name">
                      <span>{t('allClients.clientsList.nextVisit')}</span>
                      <div className="diamond-arrow" />
                    </div>
                  </th>
                  <th className="c-total-v">
                    <div role="button" tabIndex={0} onClick={() => this.sortItemClicked('totalVisits')} className="ht-name">
                      <span>{t('allClients.clientsList.totalVisits')}</span>
                      <div className="diamond-arrow" />
                    </div>
                  </th>
                  <th className="c-total-s">
                    <div role="button" tabIndex={0} onClick={() => this.sortItemClicked('totalSpend')} className="ht-name">
                      <span>{t('allClients.clientsList.totalSpend')}</span>
                      <div className="diamond-arrow" />
                    </div>
                  </th>
                  <th className="c-average">
                    <div role="button" tabIndex={0} onClick={() => this.sortItemClicked('averageBill')} className="ht-name">
                      <span>{t('allClients.clientsList.averageSpend')}</span>
                      <div className="diamond-arrow" />
                    </div>
                  </th>
                  <th className="c-no-show">
                    <div role="button" tabIndex={0} onClick={() => this.sortItemClicked('noShow')} className="ht-name">
                      <span>{t('allClients.clientsList.noShows')}</span>
                      <div className="diamond-arrow" />
                    </div>
                  </th>
                  <th className="c-cancellation">
                    <span role="button" tabIndex={0} onClick={() => this.sortItemClicked('Cancellations')} className="ht-name">
                      {t('allClients.clientsList.cancellations')}
                      <div className="diamond-arrow" />
                    </span>
                  </th>
                  <th className="c-last-patch-test">
                    <div role="button" tabIndex={0} onClick={() => this.sortItemClicked('invalid_patch_test')} className="ht-name">
                      <span>{t('allClients.clientsList.lastPatchTest')}</span>
                      <div className="diamond-arrow" />
                    </div>
                  </th>
                  <th className="c-bday">
                    <span role="button" tabIndex={0} onClick={() => this.sortItemClicked('birthday')} className="ht-name">
                      {t('allClients.clientsList.birthday')}
                      <div className="diamond-arrow" />
                    </span>
                  </th>
                  <th className="c-tags">
                    <div role="button" tabIndex={0} onClick={() => this.sortItemClicked('clientTags')} className="ht-name">
                      <span>{t('allClients.clientsList.clientTags')}</span>
                      <div className="diamond-arrow" />
                    </div>
                  </th>
                  <th className="c-lastSmsSent">
                    <div role="button" tabIndex={0} onClick={() => this.sortItemClicked('lastSmsSent')} className="ht-name">
                      <span>{t('allClients.clientsList.textLastSent')}</span>
                      <div className="diamond-arrow" />
                    </div>
                  </th>
                  <th className="c-email">
                    <div role="button" tabIndex={0} onClick={() => this.sortItemClicked('email')} className="ht-name">
                      {t('allClients.clientsList.email')}
                      <div className="diamond-arrow" />
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.props.clientList.find((client) => client.show === true) &&
                  this.props.clientList
                    .filter((client) => client.show === true)
                    .map((client, clientIndex) => {
                      const {
                        birthday,
                        patch_test_date: patchTestDate,
                        id: clientId,
                        client_tags: clientTags,
                        selected,
                        requested_opt_out: requestedOptOut,
                        stopped_sms: stoppedSms,
                        user_name: userName,
                        phone,
                        last_visit: lastVisit,
                        next_visit: nextVisit,
                        visits_count: visitsCount,
                        visits_total_cost: visitsTotalCost,
                        no_shows_count: noShowsCount,
                        canceled_count: canceledCount,
                        last_marketing_message: lastMarketingMessage,
                        email,
                      } = client ?? {};

                      return (
                        <tr
                          key={createNodeKey({
                            unique: clientId,
                            index: clientIndex,
                          })}
                        >
                          <td className="checkbox-td">
                            <div className="checkbox-box-custom-wrap">
                              <input
                                type="checkbox"
                                className="checkbox-box-custom"
                                id={`clients-check-${clientId}`}
                                checked={selected && !requestedOptOut && !stoppedSms}
                                onChange={() => void this.toggleItemChange(clientId, selected)}
                                disabled={requestedOptOut === true && stoppedSms === true}
                              />
                              <label className="checkbox-box-label" htmlFor={`clients-check-${clientId}`}>
                                <div className="checkbox-box-custom-icon">
                                  <span className="ic-sml-18px ic_check_white_18" />
                                </div>
                              </label>
                              <div hidden={requestedOptOut !== true}>
                                <span className="tooltip">
                                  <div className="tooltip-centered">{t('allClients.clientsList.optedOutMarketingTexts')}</div>
                                </span>
                              </div>
                              <div hidden={stoppedSms !== true}>
                                <span className="tooltip">
                                  <div className="tooltip-centered">{t('allClients.clientsList.optedOutAllTexts')}</div>
                                </span>
                              </div>
                            </div>
                          </td>
                          <td className="c-name text-cap">{userName}</td>
                          <td className="c-mobile">{phone}</td>
                          {lastVisit && <td className="c-last-v">{formatDateByLocale(new Date(lastVisit), { dateFormat: 'D MMM YYYY' })}</td>}
                          {!lastVisit && <td className="c-last-v">-</td>}
                          <td className="c-next-v">{nextVisit ? formatDateByLocale(new Date(nextVisit), { dateFormat: 'D MMM YYYY' }) : ' '}</td>
                          <td className="c-total-v">{visitsCount}</td>
                          <td className="c-total-s">
                            <CurrencySign />
                            {visitsTotalCost}
                          </td>
                          <td className="c-average">
                            <CurrencySign />
                            {Math.round(visitsCount === 0 ? 0 : ((visitsTotalCost / visitsCount) * 100) / 100)}
                          </td>

                          <td className="c-no-show">{noShowsCount}</td>
                          <td className="c-cancellation">{canceledCount}</td>
                          <td className="c-last-patch-test">{fromPatchTestDateToFormatted(patchTestDate)}</td>
                          <td className="c-bday">{fromBirthdayToFormatted(birthday)}</td>
                          <td className="c-tags">
                            <div className="marketing-tags-list">
                              {asArray(clientTags).map(({ emoticon, name, id }, index) => (
                                <div
                                  className="tag-icon"
                                  key={createNodeKey({
                                    unique: id,
                                    index,
                                  })}
                                >
                                  {emoticon}
                                  {S.space}
                                  {name}
                                </div>
                              ))}
                            </div>
                          </td>
                          <td className="c-lastSmsSent">{lastMarketingMessage ? moment(lastMarketingMessage).format('D MMM  YY') : '-'}</td>
                          <td className="c-email" style={{ wordBreak: 'break-all' }}>
                            {email}
                          </td>
                        </tr>
                      );
                    })}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation()(ClientList);
